/**
 * AMAÇ: Google Analytics 4 (gtag.js) yükleyici. VITE_GA_MEASUREMENT_ID tanımlı
 * değilse (yerelde/CI'de olduğu gibi) hiç yüklenmez.
 *
 * Önceden self-hosted, çerezsiz Plausible kullanılıyordu; GA4'e geçildi (bkz.
 * Gizlilik Politikası "Çerezler ve Kullanım Analitiği" — GA4 çerez kullanır ve
 * IP'nin son oktetini varsayılan olarak anonimleştirir).
 *
 * initGoogleAnalytics() bilerek import-time yan etkisi DEĞİL, main.jsx'in açıkça
 * çağırdığı bir fonksiyon: logger.js bu dosyadan toGaEventName import ettiği için
 * Rollup, script enjeksiyon kodunu (eskiden burada modül gövdesinde dururken)
 * logger.js'in de kullandığı paylaşılan bir chunk'a taşıyor — o chunk, main.jsx'in
 * "her şeyden önce" diye ithal ettiği trustedTypes.js'in kayıtlı olduğu chunk'tan
 * ÖNCE değerlendirilebiliyor (ESM: bir chunk'ın import ettiği bağımlılıklar,
 * kendi gövdesinden önce çalışır). Sonuç: script.src ataması trustedTypes policy'si
 * kayıtlı olmadan çalışıp "TrustedScriptURL" hatasıyla TÜM uygulamayı (main.jsx'in
 * render çağrısına hiç ulaşmadan) çökertiyordu — 2026-09-18'de canlıda birebir
 * yaşandı. Fonksiyon çağrısı main.jsx'in KENDİ gövdesinde, trustedTypes importundan
 * sonra çalıştığı için hangi chunk'ta durduğu artık önemsiz; policy garanti kayıtlı.
 */
export function initGoogleAnalytics() {
  const id = import.meta.env.VITE_GA_MEASUREMENT_ID;
  if (!id) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', id);

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
}

// logger.js'in kullanıcı aksiyonu event'i gönderirken kullandığı ortak dönüştürücü —
// GA4 event adları [a-z0-9_], <=40 karakter bekler; insan-okunur Türkçe mesajları
// (ör. "Kullanıcı giriş yaptı" → "kullanici_giris_yapti") buna çeviriyoruz. Yan etkisiz
// saf bir fonksiyon olduğundan hangi chunk'ta durduğunun önemi yok.
export const toGaEventName = (message) => message
  .replace(/[İIı]/g, 'i')
  .normalize('NFD').replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '_')
  .replace(/^_+|_+$/g, '')
  .slice(0, 40);
